module.exports = __webpack_public_path__ + "static/media/App.0af3d919.less";